import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';

    interface Props {
        className?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'Bank',
  props: {
    className: {}
  },
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className)
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.2798 6.70914C15.3842 6.70917 15.4876 6.68985 15.5841 6.6523C15.6805 6.61475 15.7682 6.5597 15.842 6.49029C15.9158 6.42089 15.9744 6.33849 16.0143 6.2478C16.0543 6.15711 16.0748 6.05992 16.0748 5.96176V3.71962C16.0749 3.5628 16.0224 3.40995 15.9249 3.28274C15.8273 3.15553 15.6896 3.06043 15.5314 3.01093L8.37635 0.768786C8.21306 0.717696 8.03655 0.717696 7.87326 0.768786L0.718259 3.01093C0.559977 3.06043 0.422295 3.15553 0.324746 3.28274C0.227198 3.40995 0.174736 3.5628 0.174805 3.71962V5.96176C0.174778 6.05992 0.195322 6.15711 0.235265 6.2478C0.275208 6.33849 0.333766 6.42089 0.407594 6.49029C0.481422 6.5597 0.569073 6.61475 0.665539 6.6523C0.762005 6.68985 0.865396 6.70917 0.969805 6.70914H1.7648V12.0785C1.30111 12.2321 0.89934 12.5168 0.614652 12.8936C0.329964 13.2704 0.176317 13.7208 0.174805 14.1829V15.6777C0.174778 15.7759 0.195322 15.8731 0.235265 15.9637C0.275208 16.0544 0.333766 16.1368 0.407594 16.2062C0.481422 16.2756 0.569073 16.3307 0.665539 16.3682C0.762005 16.4058 0.865396 16.4251 0.969805 16.4251H15.2798C15.3842 16.4251 15.4876 16.4058 15.5841 16.3682C15.6805 16.3307 15.7682 16.2756 15.842 16.2062C15.9158 16.1368 15.9744 16.0544 16.0143 15.9637C16.0543 15.8731 16.0748 15.7759 16.0748 15.6777V14.1829C16.0733 13.7208 15.9196 13.2704 15.635 12.8936C15.3503 12.5168 14.9485 12.2321 14.4848 12.0785V6.70914H15.2798ZM14.4848 14.9303H1.7648V14.1829C1.76502 13.9848 1.84884 13.7948 1.99789 13.6547C2.14693 13.5146 2.34902 13.4358 2.5598 13.4356H13.6898C13.9006 13.4358 14.1027 13.5146 14.2517 13.6547C14.4008 13.7948 14.4846 13.9848 14.4848 14.1829V14.9303ZM3.3548 11.9408V6.70914H4.9448V11.9408H3.3548ZM6.5348 11.9408V6.70914H9.7148V11.9408H6.5348ZM11.3048 11.9408V6.70914H12.8948V11.9408H11.3048ZM1.7648 5.21438V4.25826L8.1248 2.265L14.4848 4.25826V5.21438H1.7648Z",
      fill: "currentColor"
    }, null, -1)
  ]), 2))
}
}

})